import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { fetchReportDetails } from '../action';
import { SYSTEMDEFINED,INTERNATIONAL } from '../../../Analyst/Cases/constants';
import {
    Nav,NavItem,ButtonGroup,TabContent,Row, Col,TabPane, Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import moment from 'moment';
import SectionList from '../SectionList/index';
import Modal from '../../../components/UI/Modal/Modal';
import PdfView from '../../../components/ReusableComponents/SurveyView/index';
// import speedometer from '../../assets/images/speedometer-bg.png';
import './report.scss';
// import { viewPublishedReport } from '../../../Analyst/Cases/View/action';
// import ReactSpeedometer from "react-d3-speedometer";
import CanvasMeter from 'canvas-meter';
import { LONG_DATE_FORMAT, CURRENCY_FORMAT_FULL_FIGURES,DATA,PREDEFINED,VIDEO_KYC,FINANCIAL,CURRENCY_FORMAT_LAKH, CURRENCY_FORMAT_MN, CURRENCY_FORMAT_BN, CURRENCY_FORMAT_K, CURRENCY_FORMAT_CR } from '../../../constants';
import RiskGradePopover from '../popover';
import { getSpeedoSkin } from '../speedometerconfig';
import { getSpeedometerValues, formatNumbers, formatCurrency,sectionDetails } from '../helper';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
import Select from 'react-select';
const BPR = "Business Profile Report";
class Report extends Component {
    constructor() {
        super();
        this.state = {
            fetchPdf: null,
            riskGradeData: [],
            popoverOpen: false,
            paidupCapCurrencyFormatDropdownOpen: false,
            authCapSelectedCurrencyFormat: CURRENCY_FORMAT_FULL_FIGURES,
            paidupCapSelectedCurrencyFormat: CURRENCY_FORMAT_FULL_FIGURES,
            authCap: "",
            paidupCap: "",
            speedometer: null,
            selectedOption: undefined,
            reportList: [],
            templateSelectedOption : undefined,
            sectionList:[],
            sectionListData:[],
            tabData:null,
            pdfFile:null,
            tabContent:null,
            noPdfMessage: '',
            isExcelButtonVisible:false,
            isRefreshButtonVisibleList:null,
            isRefreshButtonVisible:false,
            selectedObj : null,
            showModal: false,

        }
    }
    componentDidMount() {
        setPageView('/Corporate/Report', document.location.href)
    }
    componentDidUpdate(prevProps) {
        const { counterPartyReportDetails, fetchPdf, reportListResponse,getAllSections,sectionPdf,selectedCompanyName } = this.props;
        if (counterPartyReportDetails !== prevProps.counterPartyReportDetails) {
            
            let CurrentDate= new Date(counterPartyReportDetails.lastUpdatedAt)
            let oldReportDate = new Date("04/01/2022")
            if(oldReportDate >=CurrentDate)
            {
                this.setState({isExcelButtonVisible:true})
            }

            const meterValues = getSpeedometerValues(counterPartyReportDetails.riskGradeSummaryList, counterPartyReportDetails.totalScore);
            const meter = new CanvasMeter(document.getElementById("risk-meter"));
            meter.draw(meterValues.totalScore, meterValues.min, meterValues.max, 45, 45);
            meter.setOptions(getSpeedoSkin(meterValues));
            this.setState({
                riskGradeData: counterPartyReportDetails.riskGradeSummaryList,
                authCap: formatCurrency(counterPartyReportDetails.authorizedCapital, counterPartyReportDetails.caseType),
                paidupCap: formatCurrency(counterPartyReportDetails.paidUpCapital, counterPartyReportDetails.caseType),
                speedometer: meter
            })
        }
        if (fetchPdf.error && fetchPdf !== prevProps.fetchPdf) {
            if (fetchPdf.error) {
                this.setState({
                    fetchPdf: <span className="text-danger">{(fetchPdf.error.response && fetchPdf.error.response.data) ? fetchPdf.error.response.data.message : "Something went wrong! Please try again."}</span>
                })
            }
        } else if (fetchPdf.data && fetchPdf !== prevProps.fetchPdf) {
            const temp = {
                sesectionData: '',
                pdfUrl: fetchPdf.data
            }
            this.setState({
                fetchPdf: <PdfView {...temp} />
            })
        }
        if (reportListResponse != prevProps.reportListResponse) {
            let reportOptions = [];
            reportListResponse && reportListResponse.data.length > 0 &&
                reportListResponse.data.map(reportObj => {
                    reportOptions = [
                        ...reportOptions, {
                            value: reportObj.computedReportId, label: reportObj.corporateName + '|'+(reportObj.caseType === 'INTERNATIONAL' ? reportObj.country.name : reportObj.zone) + ' | ' + moment(reportObj.completedDate).format(LONG_DATE_FORMAT) + ' | ' + reportObj.reportCategoryName
                        }
                    ]
                })
            let selectedOption = reportOptions.length > 0 ? reportOptions[reportOptions.findIndex(x => x.value === this.props.match.params.id)] : undefined;
            let refreshButtonMap = [];
            let selectedComputedReportObj = null;
            reportListResponse && reportListResponse.data.length > 0 &&
                reportListResponse.data.map(reportObj => {
                    refreshButtonMap = [
                        ...refreshButtonMap, {
                            value: (Math.floor((new Date().getTime() - new Date(reportObj.completedDate).getTime())/ (1000 * 60 * 60 * 24)) < 31 ) && reportObj.reportCategoryName === BPR && reportObj.bprCheck !== true ?true:false, label: reportObj.computedReportId
                        }
                    ]
                    if(reportObj.computedReportId === this.props.match.params.id){
                        selectedComputedReportObj = reportObj;
                    }
                })
                let isRefreshButtonVisible = false;
                for(let i = 0; i< refreshButtonMap.length; i++) {
                    if(refreshButtonMap[i].label === this.props.match.params.id) {
                        isRefreshButtonVisible = refreshButtonMap[i].value;
                        break;
                    }
                }
            this.setState({ templateSelectedOption: selectedOption, reportList: reportOptions, selectedOption: selectedOption,isRefreshButtonVisibleList:refreshButtonMap,isRefreshButtonVisible:isRefreshButtonVisible,selectedObj:selectedComputedReportObj})
        }

        if (getAllSections !== prevProps.getAllSections) {
            this.setState({
                sectionListData: getAllSections
            })
        }
        if (sectionPdf !== prevProps.sectionPdf) {
            const temp = {
                sectionData: this.state.tabData,
                pdfUrl: this.props.sectionPdf.data
            }
            if (temp.pdfUrl) {
                this.setState({
                    pdfFile: <PdfView {...temp} />
                })
            } else {
                this.setState({
                     noPdfMessage: null
                })
            }
        }
        if(selectedCompanyName && selectedCompanyName.companyName) {
            sessionStorage.setItem('selectedCompanyName', selectedCompanyName.companyName);
        }

    }

    handleChange = selectedOption => {
        this.setState({ selectedOption: selectedOption });
        this.props.history.push(`/credit-worthiness/${this.props.match.params.counterPartyId}/${this.props.match.params.counterPartyType}/${selectedOption.value}`)
        window.location.reload();
        this.props.fetchReportDetails(selectedOption.value);
    };

    riskGradesPopoverToggle = () => {
        if (!this.state.popoverOpen) {
            goolgeAnalyticsEvents('Corporate', 'View Risk Grade For Speedometer', 'View Risk Grades', '');
        }
        this.setState((prevState) => ({
            popoverOpen: !prevState.popoverOpen
        }))
    }


    paidupCapCurrencyDropdownToggleHandler = () => {
        this.setState((prevState) => ({
            paidupCapCurrencyFormatDropdownOpen: !prevState.paidupCapCurrencyFormatDropdownOpen
        }))
    }

    CurrencyFormatChangeHandler = (event) => {
        goolgeAnalyticsEvents('Corporate', 'Update Report Currency Type', 'Report Currency Type', event.target.innerText);
        let paidupCap = formatNumbers(event, this.props.counterPartyReportDetails.paidUpCapital)
        let authCap = formatNumbers(event, this.props.counterPartyReportDetails.authorizedCapital);
        this.setState({
            paidupCapSelectedCurrencyFormat: event.target.innerText,
            paidupCap: paidupCap,
            authCapSelectedCurrencyFormat: event.target.innerText,
            authCap: authCap
        });
    }

    handleToggle = (e, sectionNo) => {
        const sectionDetail = sectionDetails(this.state.sectionListData.data, sectionNo);
        this.setState({
            tabData: sectionDetail
        }, () => {
            if (this.state.tabData.sectionType === SYSTEMDEFINED) {
                if (this.state.tabData.surveyPdfFile) {
                    this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
                }
            } else {
                this.setState({
                    downloadAction: (this.state.tabData.sectionType !== INTERNATIONAL) ?
                        <Button outline color="primary" title="Download Section Excel">
                            <i className="fa fa-download"></i>
                        </Button> : ''})
            }
            if (this.state.tabData.surveyPdfFile) {
                this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
            }
        })
        this.updateTabContent([sectionDetail]);
    }

    updateTabContent = (data) => {
        let temp = {
            sectionData: data[0],
            pdfUrl: null
        };
        if (data[0].surveyPdfFile === null) {
            if (data[0].sectionType === DATA || data[0].sectionType === VIDEO_KYC || data[0].sectionType === FINANCIAL || data[0].sectionType === INTERNATIONAL) {
                this.setState({
                    noPdfMessage: <span className="no-pdf-message"><i className="fa fa-exclamation-circle"></i>&nbsp;Survey Response Not present</span>,
                    pdfFile: null
                })
            } else if (data[0].sectionType === PREDEFINED || data[0].sectionType === SYSTEMDEFINED) {
                this.setState({
                    noPdfMessage: <span className="no-pdf-message"><i className="fa fa-exclamation-circle"></i>&nbsp;{(data[0].sectionType === SYSTEMDEFINED) ? 'System Defined' : 'Predefined'} Section Not Edited</span>,
                    pdfFile: null
                })
            }
        } else {
            this.setState({
                noPdfMessage: null,
                pdfFile: <PdfView {...temp} />
            })
        }
        this.setState({
            tabContent: data.map(p => {
                return (
                    <TabPane key={p.order}  /* tabId={p.subcaseNo} */>
                        <Row>
                            <Col>
                                <strong>Section Name: </strong>{p.reportDisplayName==null?p.displayName:p.reportDisplayName}
                                <br/>
                                <br/>
                            </Col>
                        </Row>
                    </TabPane>
                )

            })
        })
    }
    handleModalToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            warning: ""
        }))
    }
    handleRequest = () => {
        this.props.placeRefreshReport(this.state.selectedObj)
    }
    handleConfirmation = () => {
        this.handleModalToggle();
        this.setState({
            body: <div>
                Are you sure you want to place refresh report ?
                 <br />
                <Button color="success" className="ml-1 mt-5" onClick={this.handleRequest}>OK</Button>
                <Button color="danger" className="mt-5 ml-1" onClick={this.handleModalToggle}>Cancel</Button>
            </div>
        })
    }
    render() {
        let riskDescription;
        if (this.props.counterPartyReportDetails.riskGradeSummaryList) {
            let riskGradeElement = this.props.counterPartyReportDetails.riskGradeSummaryList.find((elem) => {
                return elem.riskGrade === this.props.counterPartyReportDetails.computedRiskGrade
            });
            if (riskGradeElement) {
                riskDescription = riskGradeElement.riskDescription;
            }
        }
        
        return (
            <Col className="report">
                <Row>
                    <Col className="p-0 p-sm-3">
                        <Card>
                            <CardHeader className="report-header d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
                                <h5 className="mb-1 mb-sm-0">{this.props.selectedCompanyName.companyName || this.props.counterPartyReportDetails.companyName || sessionStorage.getItem('selectedCompanyName')}</h5>
                                {/*<div className="last-update">
                                    <label className="mb-0">Last Updated:&nbsp;</label>
                                    <span>{moment(this.props.counterPartyReportDetails.lastUpdatedAt).format(LONG_DATE_FORMAT)}</span>
                                </div>*/}
                                {this.state.reportList.length === 1 ?
                                <span>{this.state.reportList[0].label} </span> :
                                <Col className="text-dark" sm={11}>
                                    <Select className="mb-1 mb-sm-0"
                                        value={this.state.selectedOption}
                                        onChange={this.handleChange}
                                        options={this.state.reportList} />
                                </Col>
                                }
                            </CardHeader>
                            <CardBody className="p-0 p-sm-3">
                                {this.props.counterPartyReportDetails.computedRiskGrade !== undefined && this.props.counterPartyReportDetails.computedRiskGrade !== null && !this.props.hideRiskMeter &&
                                <Row noGutters className="mb-3 border">
                                    <Col xs="24" sm={this.props.counterPartyReportDetails.companyActivity ? ((this.props.counterPartyReportDetails && this.props.counterPartyReportDetails.nicCode) ? "10" : "24") : (this.props.counterPartyReportDetails.nicCode ?"12" : "24")} className="report-block">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header d-flex justify-content-between">
                                                <h4>Rubix Risk Score</h4>
                                                <Button size="sm" color="link" onClick={this.riskGradesPopoverToggle} id="Popover1">
                                                    <i className="icon-info"></i>
                                                </Button>
                                                <RiskGradePopover
                                                    riskGradeData={this.state.riskGradeData}
                                                    popoverOpen={this.state.popoverOpen}
                                                    toggle={this.riskGradesPopoverToggle}
                                                    highlighted={this.props.counterPartyReportDetails.computedRiskGrade} />
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                                <div className="speedometer-wrapper" style={{ textAlign: 'center' }}>
                                                    <canvas height="250" id="risk-meter"></canvas>
                                                </div>
                                                <div className="text-center title mt-3">
                                                    {this.props.counterPartyReportDetails.computedRiskGrade}&nbsp; &nbsp; ({riskDescription})
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    {(this.props.counterPartyReportDetails && this.props.counterPartyReportDetails.nicCode) && <Col xs="24" sm={this.props.counterPartyReportDetails.companyActivity ? "8" : "12"} className="report-block border-xs-top border-sm-left">
                                        <Card className="h-100">
                                        {(!this.props.counterPartyReportDetails.nicCode) ? "" :<CardHeader className="bg-light report-block-header">
                                                <h4>NIC Code</h4>
                                            </CardHeader>}
                                            <CardBody className="report-block-body">
                                                <p>
                                                    {this.props.counterPartyReportDetails.nicCode}
                                                </p>
                                            </CardBody>
                                            {(!this.props.counterPartyReportDetails.nicDesc) ? "" :<CardHeader className="bg-light report-block-header">
                                                <h4>NIC Code Description</h4>
                                            </CardHeader>}
                                            <CardBody className="report-block-body">
                                                <p>
                                                    {this.props.counterPartyReportDetails.nicDesc}
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col>}
                                    {(this.props.counterPartyReportDetails && this.props.counterPartyReportDetails.nicCode && this.props.counterPartyReportDetails.companyActivity) && <Col xs="24" sm="6" className="report-block border-xs-top border-sm-left">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header">
                                                <h4>Activity</h4>
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                                <p>{this.props.counterPartyReportDetails.companyActivity}</p>
                                            </CardBody>
                                        </Card>
                                    </Col>}
                                </Row>
                                }
                              {(!this.props.counterPartyReportDetails.nicCode ) ? <Row>{(this.props.counterPartyReportDetails && !this.props.counterPartyReportDetails.nicCode && this.props.counterPartyReportDetails.companyActivity) && < Col xs="24" sm="24" className="report-block border-xs-top border-sm-left">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header">
                                                <h4>Activity</h4>
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                                <p>{this.props.counterPartyReportDetails.companyActivity}</p>
                                            </CardBody>
                                        </Card>
                                    </Col>}
                                    </Row> : ""}
                                {this.props.counterPartyReportDetails.companyStatus && this.props.counterPartyReportDetails.computedRiskGrade !== undefined && this.props.counterPartyReportDetails.computedRiskGrade !== null &&
                                <Row className="mb-3">
                                    {window.location.pathname.split('/')[window.location.pathname.split('/').length-1] === this.props.counterPartyReportDetails.computedReportId && <Col>
                                        <Card>
                                            <CardHeader className="report-sub-header">
                                                <h6>Business Facts</h6>
                                            </CardHeader>
                                            <CardBody className="py-0 border border-top-0">
                                                <Row>
                                                    <Col xs="24" sm="9" md="12" lg="9" className="report-block py-3 col-9">
                                                        <ul>
                                                            {(!this.props.counterPartyReportDetails.classOfCompany) ? "" :<li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Class of Company</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.classOfCompany}</span>
                                                            </li>}
                                                            {(!this.props.counterPartyReportDetails.companyStatus) ? "" :<li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Company Status</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.companyStatus}</span>
                                                            </li>}
                                                            {(!this.props.counterPartyReportDetails.dateOfIncorporation) ? "" :<li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Incorporation</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.dateOfIncorporation}</span>
                                                            </li>}
                                                            {(!this.props.counterPartyReportDetails.lastBalanceSheetDate) ? "" :<li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Last Balance sheet</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.lastBalanceSheetDate}</span>
                                                            </li>}
                                                            {(!this.props.counterPartyReportDetails.lastGeneralMeetingDate) ? "" :<li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Last Annual General meeting</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.lastGeneralMeetingDate}</span>
                                                            </li>}
                                                        </ul>
                                                    </Col>
                                                    {(this.props.counterPartyReportDetails.paidUpCapital && this.props.counterPartyReportDetails.paidUpCapital > 0 || this.props.counterPartyReportDetails.authorizedCapital && this.props.counterPartyReportDetails.authorizedCapital > 0) && <Col xs="24" sm="4" md="12" lg="4" className="report-block col-4 px-0 py-3 text-center border-xs-top border-sm-left">
                                                        <div className="d-flex flex-column border-bottom p-3 h-50 justify-content-center">
                                                            <ButtonDropdown isOpen={this.state.paidupCapCurrencyFormatDropdownOpen} toggle={this.paidupCapCurrencyDropdownToggleHandler} direction="down" className="align-items-center">
                                                                <DropdownToggle caret color="link" block>
                                                                    {this.state.paidupCapSelectedCurrencyFormat}
                                                                </DropdownToggle>
                                                                <DropdownMenu>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_FULL_FIGURES}</DropdownItem>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_K}</DropdownItem>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_LAKH}</DropdownItem>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_CR}</DropdownItem>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_MN}</DropdownItem>
                                                                    <DropdownItem onClick={this.CurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_BN}</DropdownItem>
                                                                </DropdownMenu>
                                                            </ButtonDropdown>
                                                            <label className="report-block-title">Authorized Capital</label>
                                                            <span className="capital-value report-block-value">
                                                                {this.state.authCap}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex flex-column p-3 h-50 justify-content-center">
                                                            <label className="report-block-title">Paid up Capital</label>
                                                            <span className="capital-value report-block-value">
                                                                {this.state.paidupCap}
                                                            </span>
                                                        </div>
                                                    </Col>}
                                                    <Col xs="24" sm="6" md="12" lg="6" className="report-block col-6 profile py-3 border-xs-top border-sm-left border-md-left-0 border-md-top border-lg-top-0 border-lg-left">
                                                        <div className="profile-details d-flex flex-column">
                                                            <ul>
                                                                {(!this.props.counterPartyReportDetails.companyNumber) ? "" :<li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Company Number</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyNumber}</span>
                                                                </li>}
                                                                {(!this.props.counterPartyReportDetails.companyEmail) ? "" :<li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Email</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyEmail}</span>
                                                                </li>}
                                                                {(!this.props.counterPartyReportDetails.companyWebsite) ? "" :<li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Website</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyWebsite}</span>
                                                                </li>}
                                                            </ul>
                                                        </div>
                                                    </Col>
                                                    <Col xs="24" sm="5" md="12" lg="5" className="report-block address py-3 border-xs-top border-sm-left border-md-top border-lg-top-0 border-lg-left">
                                                        <address className="d-flex flex-column">
                                                            <span className="name">{this.props.counterPartyReportDetails.companyName}</span>
                                                            <span>{this.props.counterPartyReportDetails.companyAddress}</span>
                                                        </address>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>}
                                </Row>
                                }
                                <Row>
                                    <Col>
                                        <Card>
                                            <CardHeader className="report-sub-header d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
                                                <h5 className="mb-1 mb-sm-0">Report</h5>
                                                <div>
                                                {(this.state.isRefreshButtonVisible) ? <Button color="primary" onClick={this.handleConfirmation}>REFRESH <i className="fa fa-refresh" aria-hidden="true"></i></Button>:""}
                                                &nbsp;
                                                {(this.state.isExcelButtonVisible) ? "" : <Button color="primary" onClick={(e)=> this.props.dowloadAllcomputedSection(e)}>EXCEL <i className="fa fa-download" aria-hidden="true"></i></Button>}
                                                &nbsp;<Button color="primary" onClick={(e)=> this.props.downloadFinalReport(e)}>PDF <i className="fa fa-download" aria-hidden="true"></i></Button>
                                                </div>
                                            </CardHeader>
                                            <CardBody className="border border-top-0 p-2">
                                                <div className="row mb-4">
                                                    <div className="col-6">
                                                    <span className="header-blue d-block p-4 text-primary font-weight-bold">Sections</span>
                                                    <Nav tabs vertical className="case-sections">
                                                        <NavItem className='tabs-style'>
                                                        <Nav className="case-sections-list flex-column flex-nowrap">
                                                            <SectionList sectionData={this.state.sectionListData.data} handleToggle={this.handleToggle}/>
                                                        </Nav>
                                                        </NavItem>
                                                    </Nav>
                                                    </div>
                                                    <div className="col-18">
                                                        <Row>
                                                            <div className="col d-flex justify-content-between">
                                                                <div className="d-flex align-items-center">
                                                                    {this.state.tabContent}
                                                                </div>
                                                                <div>
                                                                    <ButtonGroup>
                                                                        {/* {this.state.downloadAction} */}
                                                                    </ButtonGroup>
                                                                </div>
                                                            </div>
                                                        </Row>
                                                    <TabContent className="mt-2">
                                                        {this.state.pdfFile}
                                                        {this.state.noPdfMessage}
                                                    </TabContent>
                                                </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                            <Modal show={this.state.showModal} className={this.state.modalClass} modalClosed={this.handleModalToggle} >
                                <strong className="text-danger">{this.state.warning}</strong>
                                {this.state.body}
                            </Modal>
                        </Card>
                    </Col>
                </Row>
            </Col>
        )
    }
}

// export default Report

const mapStateToProps = (state, ownProps) => ({
    selectedCompanyName: state.portfolio.setSelectedCompanyName
});

export default Report = connect(
    mapStateToProps
)(Report)
